import { useFieldArray, useForm } from "react-hook-form";
import { CategoryModal } from "../CategoryGrid";
import * as React from "react";
import { flattenDimensionItems, renderDimensionFormCells } from "../Category/helpers";
import { useDimensionFiltering } from "../Category/useDimensionFiltering";
import { FormInput, NumericFormInput } from "../../../../../../components/Forms";
import { useTranslation } from "react-i18next";
import { VALIDATION_PATTERNS } from "../../../../../Decarbonization/helpers";

function UseOfSoldProductsModalWrapper({ tabKey, modalData, attributesOrder, isOpen, onClose, onSubmit, getEmptyRow }) {
  const { fieldArrayName, editData, organizationStructure, dimensionItems } = modalData;
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const seededEditData = editData ? flattenDimensionItems(editData) : null;

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch
  } = useForm({
    defaultValues: {
      [fieldArrayName]: [seededEditData ? seededEditData : getEmptyRow()]
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldArrayName
  });

  const watchFieldArray = watch(fieldArrayName);

  const { getFilteredItems, setChangedRowIndex } = useDimensionFiltering({
    dimensionItems,
    editData: seededEditData,
    watchFieldArray
  });

  const mapRow = (row, index) => {
    const gridItems = [];

    gridItems.push(...renderDimensionFormCells({
      organizationStructure,
      dimensionItems,
      register,
      fieldArrayName,
      index,
      watchFieldArray,
      getFilteredItems,
      onDimensionChange: setChangedRowIndex
    }));

    gridItems.push(
      <FormInput
        errors={errors}
        {...register(`${fieldArrayName}.${index}.brand`, {
          required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.brand`) })
        })}
        title={watchFieldArray[index]?.brand}
      />
    );

    gridItems.push(
      <FormInput
        errors={errors}
        {...register(`${fieldArrayName}.${index}.itemNumber`)}
        title={watchFieldArray[index]?.itemNumber}
      />
    );

    gridItems.push(
      <FormInput
        errors={errors}
        {...register(`${fieldArrayName}.${index}.itemDescription`)}
        title={watchFieldArray[index]?.itemDescription}
      />
    );

    gridItems.push(
      <NumericFormInput
        errors={errors}
        type="number"
        {...register(`${fieldArrayName}.${index}.gasConsumptionItem`, {
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
      />
    );

    gridItems.push(
      <NumericFormInput
        errors={errors}
        type="number"
        {...register(`${fieldArrayName}.${index}.electricityConsumptionItem`, {
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
      />
    );

    gridItems.push(
      <NumericFormInput
        errors={errors}
        type="number"
        {...register(`${fieldArrayName}.${index}.averageExpectedLifeSpan`, {
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
      />
    );

    gridItems.push(
      <NumericFormInput
        errors={errors}
        type="number"
        {...register(`${fieldArrayName}.${index}.numberOfItemSold`, {
          required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.numberOfItemSold`) }),
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
      />
    );

    return gridItems;
  };

  return (
    <CategoryModal
      modalData={modalData}
      formData={{ handleSubmit, fields, append, remove }}
      attributesOrder={attributesOrder}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      getEmptyRow={getEmptyRow}
      mapRow={mapRow}
    />
  );
}

export default UseOfSoldProductsModalWrapper;
